// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nz-0";
export var assigneeDetails = "_nz-1";
export var assigneeInfo = "_nz-2";
export var dropdownContainer = "_nz-4";
export var dropdownImage = "_nz-5";
export var editAssigneeInfo = "_nz-3";
export var editAssigneeModalContainer = "_nz-6";
export var hidden = "_nz-8";
export var input = "_nz-7";